import { ThemeOptions } from '@mui/material';
import { red } from '@mui/material/colors';
import styleVariables from '../styles/styleVariables';

const themeDarkConfig = {
	palette: {
		mode: 'dark',
		text: {
			primary: '#FFF',
			secondary: '#FFF',
			disabled: '#FFF',
			hint: '#FFF',
		},
		background: {
			default: '#1A2B48',
			paper: '#1A2B48',
		},
		primary: {
			main: '#FFF',
			dark: '#1A2B48',
		},
		secondary: {
			main: styleVariables.secondaryColor,
			dark: styleVariables.secondaryColor,
			contrastText: '#FFF',
		},
		error: {
			main: red.A400,
		},
		info: {
			main: '#1A2B48',
		},
	},
	typography: {
		h1: {
			color: '#FFF',
		},
		h2: {
			color: '#FFF',
		},
		h3: {
			marginTop: '0px',
			color: styleVariables.secondaryColor,
		},
	},
	components: {
		MuiInput: {
			styleOverrides: {
				root: {
					border: 'none',
					color: 'white',
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					backgroundColor: 'white',
					padding: '0px',
					'& fieldset': {
						border: '1px solid #FFF',
						color: '#1A2B48',
					},
					color: '#1A2B48',
					'& .MuiSelect-iconOutlined': {
						color: '#FFF',
					},
				},
				input: {
					fontSize: '0.95rem',
				},
				sizeSmall: {
					fontSize: '0.8125rem',
				},
			},
		},
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
					background: '#1A2B48',
					boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.19);',
					color: 'white',
				},
			},
		},
		MuiAutocomplete: {
			styleOverrides: {
				root: {
					background: '#1A2B48',
					boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.19);',

					color: 'white',
					'& .MuiInputLabel-root': {
						backgroundColor: '#1A2B48',
						color: 'white',
					},
					'& .MuiInputBase-root': {
						backgroundColor: '#1A2B48',
						color: 'white',
					},
					'& .MuiAutocomplete-input': {
						color: 'white',
					},
					'& .MuiSvgIcon-root': {
						color: 'white',
					},
					'& .MuiOutlinedInput-root': {
						backgroundColor: '#1A2B48',
					},
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				elevation: {
					boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.19);',
					background: '#1A2B48',
				},
				outlined: {
					boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.19);',
					border: '0px',
					background: '#1A2B48',
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.19);',
					background: '#E2E8F1',
				},
			},
		},
		MuiDrawer: {
			styleOverrides: {
				paper: {
					background: '#152540',
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					color: '#FFF',
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiInputBase-input': {
						color: 'white',
					},
					'& label': {
						fontSize: '0.9375rem',
						color: '#FFF',
					},
					'& .MuiInputLabel-root': {
						padding: '0px 4px',
						borderTopRightRadius: '6px',
						borderTopLeftRadius: '6px',
						backgroundColor: styleVariables.primaryColor,
					},
					'& .MuiOutlinedInput-root': {
						backgroundColor: '#1A2B48',
						color: '#FFF',
					},
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					'& .MuiInputBase-input': {
						background: '#1A2B48',
						color: 'white',
					},
					'& label': {
						fontSize: '0.9375rem',
						color: '#FFF',
					},
				},
			},
		},
	},
} as ThemeOptions;

export default themeDarkConfig;
